import { ArrowRight } from "lucide-react";
import { glassCardHover } from "../../utils/glassStyles";

const accentMap = {
  blue: "from-primary/20 to-accent/5 border-primary/30 text-primary dark:text-accent",
  green: "from-primary/20 to-primary/5 border-primary/30 text-primary dark:text-primary",
  purple: "from-accent/20 to-accent/5 border-accent/30 text-accent dark:text-accent",
  orange: "from-orange-500/20 to-amber-500/5 border-orange-400/30 text-orange-600 dark:text-orange-400",
  yellow: "from-yellow-500/20 to-amber-500/5 border-yellow-400/30 text-yellow-600 dark:text-yellow-400",
  amber: "from-amber-500/20 to-orange-500/5 border-amber-400/30 text-amber-600 dark:text-amber-400",
  red: "from-red-500/20 to-rose-500/5 border-red-400/30 text-red-600 dark:text-red-400",
};

export default function RecruiterStatCard({
  title,
  value,
  hint,
  icon: Icon,
  accent = "blue",
  onClick,
}) {
  const accentClass = accentMap[accent] || accentMap.blue;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!onClick}
      className={`text-left w-full rounded-2xl p-5 sm:p-6 ${glassCardHover} bg-gradient-to-br ${accentClass} ${
        onClick ? "cursor-pointer hover:-translate-y-0.5" : "cursor-default"
      } transition-all duration-300`}
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className={`p-2.5 rounded-xl bg-white/30 dark:bg-white/10 backdrop-blur-sm`}>
          {Icon && <Icon className="w-5 h-5 sm:w-6 sm:h-6" />}
        </div>
        {onClick && (
          <ArrowRight className="w-4 h-4 text-muted-foreground opacity-70 group-hover:translate-x-0.5 transition-transform" />
        )}
      </div>
      <p className="text-xs sm:text-sm font-medium text-muted-foreground">{title}</p>
      <p className="text-2xl sm:text-3xl font-bold mt-1">{value}</p>
      {hint && <p className="text-xs text-muted-foreground mt-1.5">{hint}</p>}
    </button>
  );
}
